import { Field, reduxForm } from "redux-form";
import { Input, Button } from "expano-components";
import { Main } from "layouts";
import { createBrandLabel } from "actions/brand_labels";

import { ReactComponent as StickerIcon } from "icons/sticker.svg";
import { ReactComponent as InfoIcon } from "icons/info.svg";
import ImageField from "../components/ImageField";

const InputField = (props) => <Input {...props} />;

const BrandLabelNew = ({
  pristine,
  invalid,
  submitting,
  history,
  handleSubmit,
}) => {
  const onSubmit = (values) =>
    createBrandLabel(values).then((id) => history.push(`/brand-labels/${id}`));

  return (
    <Main
      page={{
        name: "Nowa etykieta markowa",
        icon: <StickerIcon />,
        breadcrumbs: [
          { name: "Etykiety markowe", path: "/brand-labels" },
          { name: "Nowa etykieta markowa" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="dashboard column-half m-t-10">
          <header className="dashboard__header">
            <div className="icon__container">
              <InfoIcon />
            </div>
            <h2 className="dashboard__title heading">Podstawowe dane</h2>
          </header>
          <form
            noValidate
            onSubmit={handleSubmit(onSubmit)}
            className="dashboard__form p-t-20"
          >
            <Field name="name" label="Nazwa" component={InputField} />
            <Field
              name="image_data"
              label="Podgląd etykiety"
              component={ImageField}
            />
          </form>
          <div className="dashboard__form__footer">
            <Button
              disabled={invalid || pristine || submitting}
              type="save"
              text="Dodaj"
              onClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Pole wymagane";
  }
  if (!values.image_data) {
    errors.image_data = "Pole wymagane";
  }
  return errors;
};

export default reduxForm({
  form: "add-brand-label",
  validate,
  initialValues: {
    name: "",
    image_data: "",
  },
})(BrandLabelNew);
